export default "/images/41027709986d50dc0f72ccc209139099.avif";